<div class="mainpanel">
    <mat-toolbar color="primary">Award Status</mat-toolbar>
    <p>
        How ready is this award to go live? What components might be missing?
    </p>
    <div *ngIf="ViewReady">
        <h1>Award Properties</h1>

        <mat-accordion multi>
            <mat-expansion-panel class="topLevel">
                <mat-expansion-panel-header>
                    <mat-panel-title fxFlex="40">Role Rights</mat-panel-title>
                    <mat-panel-description>
                        <mat-icon class="redicon" *ngIf="Status.DefaultRoleRights.length === 0">report_problem</mat-icon>
                        <mat-icon class="greenicon" *ngIf="Status.DefaultRoleRights.length > 0">done</mat-icon>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div>
                    <p *ngIf="Status.DefaultRoleRights.length === 0">No roles set</p>
                    <div *ngIf="Status.DefaultRoleRights.length > 0">
                        <mat-card *ngFor="let role of Status.DefaultRoleRights">
                            <mat-card-header>
                                <mat-card-title>{{role.RoleName}} - {{role.Active ? 'Active' : 'Inactive'}}</mat-card-title>
                            </mat-card-header>
                            <p *ngIf="role.RightsList.length === 0">No rights set</p>
                            <ul *ngIf="role.RightsList.length > 0">
                                <li *ngFor="let right of role.RightsList">
                                    {{right.RightsName}}
                                </li>
                            </ul>
                        </mat-card>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="topLevel">
                <mat-expansion-panel-header>
                    <mat-panel-title fxFlex="40">School Groups</mat-panel-title>
                    <mat-panel-description>
                        <mat-icon class="redicon" *ngIf="Status.SchoolGroups.length === 0">report_problem</mat-icon>
                        <mat-icon class="greenicon" *ngIf="Status.SchoolGroups.length > 0">done</mat-icon>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div>
                    <p *ngIf="Status.SchoolGroups.length === 0">No school groups set</p>
                    <div *ngIf="Status.SchoolGroups.length > 0">
                        <mat-card *ngFor="let group of Status.SchoolGroups">
                            <mat-card-header>
                                <mat-card-title>Group Name: {{group.Name}}</mat-card-title>
                            </mat-card-header>
                            <ul>
                                <li *ngFor="let school of group.Schools">
                                    <span>{{school.LocationName}} {{school.LocationNumber}}</span> <span>{{school.IsGroupLeader ? ' - Lead School' : ''}}</span>
                                </li>
                            </ul>
                        </mat-card>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="topLevel">
                <mat-expansion-panel-header>
                    <mat-panel-title fxFlex="40">Judge Point Scales</mat-panel-title>
                    <mat-panel-description>
                        <mat-icon class="redicon" *ngIf="Status.PointScales.length === 0">report_problem</mat-icon>
                        <mat-icon class="greenicon" *ngIf="Status.PointScales.length > 0">done</mat-icon>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div>
                    <p *ngIf="Status.PointScales.length === 0">No point scales set</p>
                    <div *ngIf="Status.PointScales.length > 0">
                        <mat-card *ngFor="let ps of Status.PointScales">
                            <mat-card-header>
                                <mat-card-title>{{ps.Name}}</mat-card-title>
                            </mat-card-header>
							<mat-card-content>
								<p *ngIf="ps.Details.length === 0">No details set</p>
								<div *ngIf="ps.Details.length > 0">
									<div *ngFor="let d of ps.Details">
										{{d.Points}} - {{d.Text}}
									</div>
								</div>
							</mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="topLevel">
                <mat-expansion-panel-header>
                    <mat-panel-title fxFlex="40">School Eligibility</mat-panel-title>
                    <mat-panel-description>
                        <mat-icon class="redicon" *ngIf="Status.EligibilityCount === 0">report_problem</mat-icon>
                        <mat-icon class="greenicon" *ngIf="Status.EligibilityCount > 0">done</mat-icon>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div>
                    <mat-card>
                        <p><strong>Number of eligible schools: </strong>{{Status.EligibilityCount}}</p>
                    </mat-card>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <h1>Nomination Properties</h1>

        <mat-tab-group>
            <mat-tab label="{{nomination.NominationName}}" *ngFor="let nomination of Status.NomineeTypeInfoList">
                <mat-accordion multi>
                    <mat-expansion-panel class="topLevel">
                        <mat-expansion-panel-header>
                            <mat-panel-title fxFlex="40">Form Template</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon class="redicon" *ngIf="nomination.FormTemplate == null">report_problem</mat-icon>
                                <mat-icon class="greenicon" *ngIf="nomination.FormTemplate">done</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                            <p *ngIf="nomination.FormTemplate == null">No form template set</p>
                            <mat-card *ngIf="nomination.FormTemplate">
                                <p><strong>Template Name: </strong>{{nomination.FormTemplate.TemplateName}}</p>
                            </mat-card>
                            <mat-card *ngFor="let section of nomination.FormTemplate.Sections">
                                <h3><strong>Section Name: </strong>{{section.SectionName}}</h3>
                                <p>Questions:</p>
                                <ol>
                                    <li *ngFor="let question of section.QuestionList">
                                        <span>{{question.QuestionText}}</span>
                                        <div *ngIf="question.HasOptions">
                                            <strong>Options: </strong>
                                            <ul>
                                                <li *ngFor="let option of question.Options">{{option.DisplayText}}</li>
                                            </ul>
                                        </div>
                                    </li>
                                </ol>
                            </mat-card>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="topLevel">
                        <mat-expansion-panel-header>
                            <mat-panel-title fxFlex="40">Attachment Types</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon class="redicon" *ngIf="nomination.AttachmentTypes.length === 0">report_problem</mat-icon>
                                <mat-icon class="greenicon" *ngIf="nomination.AttachmentTypes.length > 0">done</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                            <p *ngIf="nomination.AttachmentTypes.length === 0">No attachment types set</p>
                            <table *ngIf="nomination.AttachmentTypes.length > 0">
                                <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th>Extensions</th>
                                        <th>Provided</th>
                                        <th>Upper Size Limit</th>
                                        <th>Lower Size Limit</th>
										<th>Photo Dimensions</th>
                                        <th>Download File</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let at of nomination.AttachmentTypes">
                                        <td>{{at.Description}}</td>
                                        <td>{{at.Extensions}}</td>
                                        <td>{{at.NomineeProvides ? 'In nomination form' : 'Not in nomination form'}}</td>
                                        <td>{{at.SizeLimit | number}}<span *ngIf="at.SizeLimit"> bytes</span></td>
                                        <td *ngIf="at.Extensions !== '.MP4'">{{at.LowerSizeLimit | number}}<span *ngIf="at.LowerSizeLimit"> bytes</span></td>
                                        <td *ngIf="at.Extensions === '.MP4'">{{at.LowerSizeLimit}}<span *ngIf="at.LowerSizeLimit"> resolution</span></td>
										<td><span *ngIf="at.Resolution">{{at.Resolution}}</span></td>
                                        <td>{{at.DownloadFile}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="topLevel">
                        <mat-expansion-panel-header>
                            <mat-panel-title fxFlex="40">RSVP Form Template</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon class="redicon" *ngIf="nomination.RsvpFormTemplate.GuestNumber == null">report_problem</mat-icon>
                                <mat-icon class="greenicon" *ngIf="nomination.RsvpFormTemplate.GuestNumber">done</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                            <p *ngIf="nomination.RsvpFormTemplate.GuestNumber == null">No RSVP form template set</p>
                            <mat-card *ngIf="nomination.RsvpFormTemplate">
                                <p>Max Guest Count: {{nomination.RsvpFormTemplate.GuestNumber == null ? 'No max guest count set' : nomination.RsvpFormTemplate.GuestNumber}}</p>
                                <p>Questions:</p>
                                <ol>
                                    <li *ngFor="let question of nomination.RsvpFormTemplate.QuestionList">
                                        <span>{{question.QuestionText}}</span>
                                        <div *ngIf="question.HasOptions">
                                            <strong>Options: </strong>
                                            <ul>
                                                <li *ngFor="let option of question.Options">{{option.DisplayText}}</li>
                                            </ul>
                                        </div>
                                    </li>
                                </ol>
                            </mat-card>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="topLevel">
                        <mat-expansion-panel-header>
                            <mat-panel-title fxFlex="40">Window Dates</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon class="redicon" *ngIf="nomination.WindowDates.length === 0">report_problem</mat-icon>
                                <mat-icon class="greenicon" *ngIf="nomination.WindowDates.length > 0">done</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                            <p *ngIf="nomination.WindowDates.length === 0">No window dates set</p>
                            <table *ngIf="nomination.WindowDates.length > 0">
                                <thead>
                                    <tr>
                                        <th>Window Name</th>
                                        <th>Open</th>
                                        <th>Begin Date</th>
                                        <th>End Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let win of nomination.WindowDates">
                                        <td>{{win.WindowTypeDescription}}</td>
                                        <td>{{win.Open ? 'Open' : 'Not Open'}}</td>
                                        <td>{{win.DateBegin | datefns: 'M/d/yyyy h:mm a'}}</td>
                                        <td>{{win.DateEnd | datefns: 'M/d/yyyy h:mm a'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="topLevel bottom">
                        <mat-expansion-panel-header>
                            <mat-panel-title fxFlex="40">Judge Rubric</mat-panel-title>
                            <mat-panel-description>
                                <mat-icon class="redicon" *ngIf="nomination.Phases.length === 0">report_problem</mat-icon>
                                <mat-icon class="greenicon" *ngIf="nomination.Phases.length > 0">done</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div>
                            <p *ngIf="nomination.Phases.length === 0">No rubrics set</p>
                            <div *ngIf="nomination.Phases.length > 0">
                                <mat-card *ngFor="let p of nomination.Phases">
                                    <div fxLayout="row" fxLayoutAlign="start center">
                                        <h3 fxFlex="20"><strong>Phase: </strong>{{p.Phase}}</h3>
                                        <button mat-raised-button color="primary" (click)="p.SectionsExpanded = !p.SectionsExpanded" *ngIf="p.Sections.length > 0">
                                            <span *ngIf="!p.SectionsExpanded">Expand</span><span *ngIf="p.SectionsExpanded">Collapse</span><span> All</span>
                                        </button>
                                    </div>
                                    <p *ngIf="p.Sections.length === 0">No sections set</p>
                                    <mat-accordion multi displayMode="flat" *ngIf="p.Sections.length > 0">
                                        <mat-expansion-panel *ngFor="let sec of p.Sections" [expanded]="p.SectionsExpanded">
                                            <mat-expansion-panel-header>
                                                <mat-panel-title fxFlex="50">{{sec.SectionName}}</mat-panel-title>
                                                <mat-panel-description>Click to see questions</mat-panel-description>
                                            </mat-expansion-panel-header>
                                            <p *ngIf="sec.Questions.length === 0">No questions set</p>
                                            <ul *ngIf="sec.Questions.length > 0">
                                                <li *ngFor="let question of sec.Questions">
                                                    <span fxFlex="50"><strong>Question: </strong>{{question.Question}}</span>
                                                    <span><strong>Point Scale: </strong>{{question.PointScale}}</span>
                                                </li>
                                            </ul>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </mat-card>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <br />
                </mat-accordion>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>